import React, {Component} from 'react';
import {Col, CustomInput, Input, Row} from "reactstrap";
import assets from "../../../../util/assets";
import {SortByComponent} from "./sort-by";
import EmptyComponent from "./empty/Empty";
import {ListItem} from "./list-item";
import classNames from "classnames";
import {MultipleSelectionCollapsableComponent} from "./multiple-selection";
import {connect} from "react-redux";
import * as actions from "../../../../actions";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "react-loading-animation";

class MyLibraryComponent extends Component {

    isEmpty = () => {
        return this.props.contentList.length === 0
    }

    render() {

        const clearTextClass = classNames({
            show: this.props.searchValue && this.props.searchValue.length > 0,
            "search-user-names-cross": true
        });


        return (
            <div>
                {
                    (!this.isEmpty() || this.props.searchValue !== "") &&
                    <Row className="display-flex-vertical-center my-library-search-container no-margin">
                        <Col className="my-library-search-library-title text-align-left ">
                            Search Library
                        </Col>
                        <Col>
                            <Input
                                maxLength={40}
                                name={"my-library-search-input"}
                                placeholder="Search with name and tags"
                                className="text-align-left my-library-search-input"
                                value={this.props.searchValue}
                                onChange={this.props.updateSearchValue}
                                onKeyPress={this.props.handleKeyPress}
                            />
                            <img className={clearTextClass}
                                 src={assets.clear_search}
                                 alt={"clear search"}
                                 onClick={() => {
                                     this.props.updateSearchValue(null)
                                 }}
                                 style={{left: 75, background: '#FFFFFF'}}
                            />
                        </Col>
                        <Col>
                            <SortByComponent sortBy={this.props.sortBy} setSortBy={this.props.setSortBy}/>
                        </Col>
                    </Row>
                }

                {
                    this.isEmpty() &&
                    this.props.my_library &&
                    this.props.my_library.hasOwnProperty("isFetching") &&
                    !this.props.my_library.isFetching &&
                    <EmptyComponent searchValue={this.props.searchValue} uploadContent={this.props.uploadContent}/>
                }

                {/* My library content header */}
                {
                    !this.isEmpty() &&
                    <Row className="my-library-table-header no-margin">
                        <Col md="8" className="no-padding">
                            <div className="display-flex">
                                <CustomInput
                                    type="checkbox"
                                    id={`mylibrary-check-all`}
                                    name={`mylibrary-check-all`}
                                    className="my-library-checkbox"
                                    checked={this.props.selectAllCheckbox}
                                    onChange={this.props.selectAllToggle}
                                />
                                <span className="my-library-table-header-title">Content</span>
                            </div>
                        </Col>
                        <Col md="2" className="no-padding">
                            <span className="my-library-table-header-title">Tags</span>
                        </Col>
                        <Col md="2" style={{textAlign: 'right'}} className="no-padding">
                            <span className="my-library-table-header-title">Actions</span>
                        </Col>
                    </Row>
                }
                {/* My library content header */}


                {/*collapsable only visible when more than one item is selected*/}
                <MultipleSelectionCollapsableComponent
                    selectAllCheckbox={this.props.selectAllCheckbox}
                    checkboxStore={this.props.checkboxStore}
                    deleteMany={this.props.deleteMany}
                    publishMany={this.props.publishMany}/>
                {/*collapsable only visible when more than one item is selected*/}


                {/* My library content list */}
                <InfiniteScroll
                    className="my-library-infinite-scroll-component"
                    dataLength={this.props.contentList.length}
                    next={this.props.loadNextPage}
                    hasMore={this.props.hasMore}
                    loader={<Loading/>}
                    endMessage={<span/>}
                >
                    {
                        this.props.contentList.map((content, index) => {
                            if(content){
                                return (
                                    <ListItem
                                        key={content.id}
                                        index={index}
                                        content={content}
                                        selectAllCheckbox={this.props.selectAllCheckbox}
                                        checkboxStore={this.props.checkboxStore}
                                        checkboxToggle={this.props.checkboxToggle}
                                        thumbnailClicked={this.props.thumbnailClicked}
                                        editVideo={this.props.editVideo}
                                        publishVideo={this.props.publishVideo}
                                        duplicateVideo={this.props.duplicateVideo}
                                        deleteVideo={this.props.deleteVideo}
                                        getVideoLink={this.props.getVideoLink}

                                        duplicate_videos={this.props.duplicate_videos}
                                        delete_videos={this.props.delete_videos}
                                        publish_videos={this.props.publish_videos}
                                        retry_video_url={this.props.retry_video_url}
                                    />
                                )
                            }
                        })
                    }
                </InfiniteScroll>
                {/* My library content list */}
            </div>
        );
    }
}

MyLibraryComponent.propTypes = {};


function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        duplicate_videos: state.clipstore_broadcaster_duplicate_videos,
        delete_videos: state.clipstore_broadcaster_delete_videos,
        publish_videos: state.clipstore_broadcaster_publish_videos,
        retry_video_url:state.clipstore_broadcaster_retry_video_url,
    };
}

export default connect(mapStateToProps, actions)(MyLibraryComponent);
